<div class="form-floating">
	<input type="text" class="form-control" id="selectInput" name="selectSearch" [(ngModel)]="selectSearch" />
	<label for="selectInput">{{ placeholder }}</label>
</div>
